import { render, staticRenderFns } from "./La1.vue?vue&type=template&id=17720de6&scoped=true&"
import script from "./La1.vue?vue&type=script&lang=js&"
export * from "./La1.vue?vue&type=script&lang=js&"
import style0 from "./La1.vue?vue&type=style&index=0&id=17720de6&prod&lang=scss&scoped=true&"
import style1 from "./La1.vue?vue&type=style&index=1&id=17720de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17720de6",
  null
  
)

export default component.exports